import { Component, h, Prop, Host } from '@stencil/core';
import AcceptedCircle from '../../../atoms/svg-elements/accepted-circle';
import ArrowBottom from '../../../atoms/svg-elements/arrow-bottom';
import CloseIcon from '../../../atoms/svg-elements/close-icon';
import { t } from '../../../../redux/utils';

@Component({
  tag: 'rtr-cart-reservation-header',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareCartControlButton {
  @Prop() onCloseButton!: () => void;
  @Prop() useArrowButton: boolean = false;

  render() {
    return (
      <Host class="CRHeader">
        <div class="CRReserved">
          <AcceptedCircle />
          <div class="CRReservedInfo">
            <span>{t('cart.articleReserved')}</span>
            <rentware-expiration-timer />
          </div>
        </div>
        <div class="GlobalButtonSVG CRHeaderButton" onClick={this.onCloseButton} tabindex="0">
          {this.useArrowButton && <ArrowBottom />}
          {!this.useArrowButton && <CloseIcon />}
        </div>
      </Host>
    );
  }
}
